module.exports = __webpack_public_path__ + "../front/img/568_bøjlestang+hylder.12378612.svg";